define( 'format-numbers',[ 'jquery', 'numeral' ],
function( $ ) {

	'use strict';

	var formatNumbers = {};

	function formatCurrencyValues(set) {
		set.each(function (i, el) {
			var $el = $(el),
					fmt = $el.data('numeric-format') || '0,0.00',
					currency = $el.data('currency'),
					val = $el.text() || $el.val(),
					num = parseFloat(val),
					text;

			if (!num) return;

			var text = numeral(num).format(fmt);
			if (currency) {
				text += (' ' + currency);
			}

			if ($el.is('input') || $el.is('textarea')) {
				$el.val(text);
				return;
			}

			$el.text(text);
		});
	}

	formatNumbers.init = function() {
		formatCurrencyValues( $( '[data-numeric-format]' ) );

		$(window).off('numericCurrencyTrigger').on('numericCurrencyTrigger', function () {
			formatCurrencyValues( $( '[data-numeric-format]' ) );
		});
	};

	return formatNumbers;
} );

